import React, { useEffect, Suspense } from "react"
import { Router, Route, Switch } from "react-router-dom"
import { connect } from "react-redux"
import { SnackbarProvider } from "notistack"
import { ParallaxProvider } from "react-scroll-parallax"
import { makeStyles } from "@mui/styles"
import Layout from "./components/Layout"
import Loading from "./components/Loading"
import PrivateRoute from "./components/PrivateRoute"
import { useAuth0 } from "./react-auth0-wrapper"
import history from "./lib/history"

import { fetchAppDetails } from "./lib/apiServices"

const Maintenance = React.lazy(() => import("./components/Maintenance"))
const Contact = React.lazy(() => import("./components/Contact"))
const Main = React.lazy(() => import("./components/Main"))
const Terms = React.lazy(() => import("./components/Terms"))
const Privacy = React.lazy(() => import("./components/Privacy"))
const Profile = React.lazy(() => import("./components/Profile"))
const Game = React.lazy(() => import("./components/Game"))
const Invite = React.lazy(() => import("./components/Invite"))
const FormGameSetupStepper = React.lazy(() => import("./components/FormGameSetupStepper"))
const ShowLoginButton = React.lazy(() => import("./components/ShowLoginButton"))

const useStyles = makeStyles(() => ({
  success: { backgroundColor: "#6772e5" },
  error: { backgroundColor: "red" },
  warning: { backgroundColor: "green" },
  info: { backgroundColor: "#FF7F50" },
}))

function App(props) {
  const { loading, loginWithRedirect } = useAuth0()
  const { dispatch } = props
  const classes = useStyles()

  useEffect(() => {
    if (process.env.REACT_APP_MAINTENANCE !== "TRUE") {
      dispatch(fetchAppDetails())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const LoginComponent = () => {
    useEffect(() => {
      loginWithRedirect({ appState: { targetUrl: "/profile" } })
    }, [])
    return <></>
  }

  return (
    <SnackbarProvider
      preventDuplicate
      classes={{
        variantSuccess: classes.success,
        variantError: classes.error,
        variantWarning: classes.warning,
        variantInfo: classes.info,
      }}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      maxSnack={3}
    >
      <Loading isLoaded={!loading} >
        <Router history={history}>
          <ParallaxProvider>
            <Layout>
              <Suspense fallback={<Loading isLoaded={false} />}>
                {process.env.REACT_APP_MAINTENANCE === "TRUE" ?
                  <Switch>
                    <Route path="/" component={Maintenance} />
                  </Switch>
                  :
                  <Switch>
                    <Route path="/play" component={FormGameSetupStepper} />
                    <Route path="/terms" component={Terms} />
                    <Route path="/privacy" component={Privacy} />
                    <Route path="/contact" component={Contact} />
                    <Route path="/invite/:inviteLinkUuid" component={Invite} />
                    <PrivateRoute path="/profile/game/:uuid/:tab?" component={Game} />
                    <PrivateRoute path="/profile" component={Profile} />
                    <Route path="/login" component={LoginComponent} />
                    <Route path="/showlogin" component={ShowLoginButton} />
                    <Route path="/" component={Main} />
                  </Switch>
                }
              </Suspense>
            </Layout>
          </ParallaxProvider>
        </Router>
      </Loading>
    </SnackbarProvider>
  )
}

export default connect()(App)
